import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_2 = { class: "min-w-0 flex-1" }
const _hoisted_3 = {
  "data-test": "location-pill",
  class: "mb-1 inline-flex max-w-full items-center truncate rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-500"
}

import BottleRow from '@/components/neue/BottleRow.vue'
import EmptyState from '@/components/neue/EmptyState.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import NeuePagination from '@/components/neue/NeuePagination.vue'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import { PAGE_SIZE } from '@/composables/useFranchiseDay'

// One page of a franchise day's bottles across locations, each under a pill naming its location.

export default {
  __name: 'FranchiseDayBottleList',
  props: {
  list: { type: Object, required: true },
  locationName: { type: Function, required: true },
  emptyLabel: { type: String, required: true }
},
  emits: ['prev', 'next'],
  setup(__props, { emit: __emit }) {



const emit = __emit

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(NeueLoading, {
    loading: __props.list.loading
  }, {
    default: _withCtx(() => [
      (__props.list.rows.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(NeueTablist, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list.rows, (bottle) => {
                  return (_openBlock(), _createBlock(TablistRow, {
                    key: bottle.id,
                    "data-test": "bottle-list-row",
                    class: "gap-4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.locationName(bottle)), 1),
                        _createVNode(BottleRow, {
                          bottle: bottle,
                          lite: ""
                        }, null, 8, ["bottle"])
                      ]),
                      _renderSlot(_ctx.$slots, "actions", { bottle: bottle })
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 3
            }),
            _createVNode(NeuePagination, {
              size: __props.list.size,
              from: __props.list.cursor + 1,
              to: __props.list.cursor + _unref(PAGE_SIZE),
              onPrev: _cache[0] || (_cache[0] = ret => emit('prev', ret)),
              onNext: _cache[1] || (_cache[1] = ret => emit('next', ret))
            }, null, 8, ["size", "from", "to"])
          ]))
        : (_openBlock(), _createBlock(EmptyState, {
            key: 1,
            plural: __props.emptyLabel,
            description: ""
          }, null, 8, ["plural"]))
    ]),
    _: 3
  }, 8, ["loading"]))
}
}

}